import ExamplesSelector from "@/components/ExamplesSelector";
import { NodeViewProps, NodeViewWrapper } from "@tiptap/react";
import React, { useCallback, useMemo } from "react";
import "./styles.css";

const DatasetExamplesDisplay = React.memo((props: NodeViewProps) => {
  const { dataset, version, examples, columns, dataType } = props.node.attrs;

  const initialConfig = useMemo(() => {
    return {
      selectedDataset: dataset || "",
      selectedVersion: version || "",
      selectedExamples:
        typeof examples === "string"
          ? examples
              ?.split(",")
              .filter((id) => id !== "")
              .map((id: string) => ({
                id: parseInt(id),
                value: {},
                text: "Example " + id,
                category: "Category A",
                difficulty: "Easy",
              })) || []
          : typeof examples === "number"
          ? [
              {
                id: examples,
                value: {},
                text: "Example " + examples,
                category: "Category A",
                difficulty: "Easy",
              },
            ]
          : examples?.map((id: string) => ({
              id: parseInt(id),
              value: {},
              text: "Example " + id,
              category: "Category A",
              difficulty: "Easy",
            })) ?? [],
      visibleColumns:
        typeof columns === "string" ? columns.split(",") : columns ?? [],
      dataType: dataType || "json",
    };
  }, [dataset, version, examples, columns, dataType]);

  const handleChange = useCallback(
    (attrs: any) => {
      props.updateAttributes({
        dataset: attrs.selectedDataset,
        version: attrs.selectedVersion,
        examples: attrs.selectedExamples?.map(({ id }: { id: number }) => id),
        columns: attrs.visibleColumns,
        dataType: attrs.dataType,
      });
    },
    [props],
  );

  const isEditable = props.editor.isEditable;

  return (
    <NodeViewWrapper className="node-dataset-examples inline-flex">
      <ExamplesSelector
        readOnly={!isEditable}
        initialConfig={initialConfig}
        showCollapsible={true}
        onChange={handleChange}
      />
    </NodeViewWrapper>
  );
});

DatasetExamplesDisplay.displayName = "DatasetExamplesDisplay";

export default DatasetExamplesDisplay;
